import { memo, PropsWithChildren } from 'react'

import { isFederation } from '../../helpers/environment'
import useMfe from '../../hooks/use-mfe'
import { useSessionStore } from '../../stores/session'

const MfeProvider: React.FC<PropsWithChildren> = memo(({ children }) => {
  const { isDataStored } = useMfe()
  const authData = useSessionStore(state => state.authData)

  const isStandaloneAuthenticated = !isFederation && !!authData.accessToken

  if (!isDataStored && !isStandaloneAuthenticated) {
    return null
  }

  return children
})

export default MfeProvider
